<div class="narrowed-container">
  <div class="row">
    <div class="col">
      <div *ngIf="authorData != null" class="row page-container">
        <div class="col-12 page-content">
          <h1
            class="my-6 text-3xl font-bold text-grey-1 md:text-4xl"
            id="page-title"
          >
            {{ authorData.acf.title }} {{ authorData.name }}
          </h1>
        </div>
        <div class="col-4 page-content author-image">
          <app-media-item
            [classList]="'widthInherit'"
            [image]="authorData.acf.mainImage"
            [isPriority]="true"
          ></app-media-item>
        </div>
        <div class="col-8 page-content prose first-of-type:prose-h2:mt-0">
          <div [innerHTML]="authorData.acf.information | safeHtml"></div>
        </div>
      </div>
    </div>

    <div class="col-s">
      <app-sidebar
        [isAdVisible]="true"
        [pageType]="pageType"
      ></app-sidebar>
    </div>
  </div>
</div>
